export default [
    {
        path: '/book/index',
        name: '贵州省普通话培训测试用书音频',
        component: r => require.ensure([], () => r(require('@/views/book/index')), 'user')
    },
    {
        path: '/book/class/:id',
        name: '贵州省普通话培训测试用书音频',
        component: r => require.ensure([], () => r(require('@/views/book/class')), 'user')
    },
    {
        path: '/book/list/:id',
        name: '贵州省普通话培训测试用书音频',
        component: r => require.ensure([], () => r(require('@/views/book/list')), 'user')
    },
    {
        path: '/book/details/:id',
        name: '贵州省普通话培训测试用书音频',
        component: r => require.ensure([], () => r(require('@/views/book/details')), 'user')
    },
    
    {
        path: '/book/buy/index',
        name: '贵州省普通话培训测试用书音频',
        component: r => require.ensure([], () => r(require('@/views/book/buy')), 'user')
    },
    {
        path: '/book/buy/code',
        name: '贵州省普通话培训测试用书音频',
        component: r => require.ensure([], () => r(require('@/views/book/code')), 'user')
    },
]


// WEBPACK FOOTER //
// ./src/router/routers/book.js